import '../less/header.less';

import { Button } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconClearUnread } from '@/assets/notifications/clear-unread.svg';
import { ReactComponent as IconSetting } from '@/assets/notifications/setting.svg';
import { readAllMessage } from '@/services/notifications';

interface INoticeHeaderProps {
  moduleId: number;
  onReadAll: (moduleId: number) => void;
}

const NoticeHeader: React.FC<INoticeHeaderProps> = ({
  moduleId,
  onReadAll,
}) => {
  const { t: $t, i18n } = useTranslation(['notifications']);

  const handleClearUnread = () => {
    readAllMessage({ id: moduleId }).then(() => {
      onReadAll(moduleId);
    });
  };

  useEffect(() => {
    document.querySelector('body')?.click();
  }, []);

  return (
    <div className="notice-header">
      <h1 className="notice-header-shadow">{$t('messageCenter')}</h1>
      <h1 data-paint>{$t('messageCenter')}</h1>
      <div className="notice-header__control">
        <div
          onClick={handleClearUnread}
          className="notice-header__control-btn notice-header__control-clear-unread"
        >
          <i>
            <IconClearUnread />
          </i>
          <span>{$t('readAll')}</span>
        </div>
        {/* 设置按钮 PC 显示 */}
        <Button
          type="link"
          href="/app/user/settings"
          className="notice-header__control-btn notice-header__control-setting-pc"
        >
          <i>
            <IconSetting />
          </i>
          <span>{$t('messageSetting')}</span>
        </Button>
        {/* 设置按钮 H5 显示 */}
        <Button
          type="link"
          href={`/${i18n.language}/notifications-setting`}
          className="notice-header__control-btn notice-header__control-setting-h5"
        >
          <i>
            <IconSetting />
          </i>
          <span>{$t('messageSetting')}</span>
        </Button>
      </div>
    </div>
  );
};

export default NoticeHeader;
